"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _designTokens = _interopRequireWildcard(require("@decisiv/design-tokens"));

var _ConfigProvider = require("../../providers/ConfigProvider");

var _dynamicModifiers = require("../../utils/dynamicModifiers");

var _focusRingWithColor = _interopRequireDefault(require("../../utils/focusRingWithColor"));

var _BaseButton = _interopRequireDefault(require("../../atoms/BaseButton"));

var _colors = require("./colors");

var _intent = _interopRequireDefault(require("./intent"));

var _kind = _interopRequireDefault(require("./kind"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var opacityColors = _designTokens.default.color.opacity,
    fontSizes = _designTokens.default.typography.size.alias,
    base = _designTokens.default.spacing.base;

var color = _styledTheming.default.variants(_ConfigProvider.themeKeys.mode, 'variant', {
  normal: {
    light: (0, _styledComponents.css)(["background-color:", ";color:", ";&:focus:not(:active){border-color:", ";", "}&:hover:not(:active){background-color:", ";}"], _colors.interactionPrimaryLight, _colors.interactionPrimaryLightFg, _colors.focusRingColors.light.normal.primary.border, (0, _focusRingWithColor.default)(_colors.focusRingColors.light.normal.primary.shadow), _colors.interactionSecondaryLight),
    dark: (0, _styledComponents.css)(["background-color:", ";color:", ";&:focus:not(:active){border-color:", ";", "}&:hover:not(:active){background-color:", ";}"], _colors.interactionPrimaryDark, _colors.interactionPrimaryDarkFg, _colors.focusRingColors.dark.normal.primary.border, (0, _focusRingWithColor.default)(_colors.focusRingColors.dark.normal.primary.shadow), _colors.interactionSecondaryDark)
  },
  inverted: {
    light: (0, _styledComponents.css)(["background-color:", ";color:", ";&:focus:not(:active){border-color:", ";", "}&:hover:not(:active){background-color:", ";color:", ";}"], _colors.interactionPrimaryLightFg, _colors.interactionPrimaryLight, _colors.focusRingColors.light.inverted.primary.border, (0, _focusRingWithColor.default)(_colors.focusRingColors.light.inverted.primary.shadow), _colors.snowWhiteAlpha, _colors.interactionPrimaryLightFg),
    dark: (0, _styledComponents.css)(["background-color:", ";color:", ";&:focus:not(:active){border-color:", ";", "}&:hover:not(:active){background-color:", ";color:", ";}"], _colors.interactionPrimaryLightFg, _colors.interactionPrimaryLight, _colors.focusRingColors.dark.inverted.primary.border, (0, _focusRingWithColor.default)(_colors.focusRingColors.dark.inverted.primary.shadow), _colors.snowWhiteAlpha, _colors.interactionPrimaryLightFg)
  },
  ghost: {
    light: (0, _styledComponents.css)(["background-color:transparent;color:", ";padding:0;&:focus:not(:active){border-color:", ";", "}&:hover:not(:active){color:", ";}"], _colors.interactionPrimaryLight, _colors.focusRingColors.light.ghost.border, (0, _focusRingWithColor.default)(_colors.focusRingColors.light.ghost.shadow), _colors.interactionSecondaryLight),
    dark: (0, _styledComponents.css)(["background-color:transparent;color:", ";padding:0;&:focus:not(:active){border-color:", ";", "}&:hover:not(:active){color:", ";}"], _colors.interactionPrimaryDark, _colors.focusRingColors.dark.ghost.border, (0, _focusRingWithColor.default)(_colors.focusRingColors.dark.ghost.shadow), _colors.interactionSecondaryLight)
  }
});
/** map the Button size values to the matching font size scalar values */


var sizeToScalarSize = {
  medium: fontSizes.default,
  small: fontSizes.paragraph2,
  large: fontSizes.header4,
  extraLarge: 18
};
/** map the Button size values to the matching heights, in rem */

var sizeToHeight = {
  medium: (0, _rem.default)(32),
  small: (0, _rem.default)(24),
  large: (0, _rem.default)(44),
  extraLarge: (0, _rem.default)(50)
};
/** map the Button size values to the matching X padding, in rem */

var sizeToPaddingX = {
  medium: (0, _rem.default)(base),
  small: (0, _rem.default)(base),
  large: (0, _rem.default)(base * 1.5),
  extraLarge: (0, _rem.default)(base * 1.5)
};

var buttonSizeModifier = function buttonSizeModifier(_ref) {
  var size = _ref.size,
      variant = _ref.variant;
  return (0, _styledComponents.css)(["font-size:", ";height:", ";padding:0 ", ";"], (0, _rem.default)(sizeToScalarSize[size]), sizeToHeight[size], variant !== 'ghost' && sizeToPaddingX[size]);
};

var disabledStyles = function disabledStyles(_ref2) {
  var variant = _ref2.variant,
      $loading = _ref2.$loading;

  if ($loading) {
    if (variant === 'ghost') {
      return (0, _styledComponents.css)(["&:disabled:disabled{border-color:transparent;color:", ";cursor:not-allowed;}"], _colors.interactionSecondaryLight);
    }

    if (variant === 'inverted') {
      return (0, _styledComponents.css)(["&:disabled:disabled{background-color:", ";border-color:transparent;color:", ";cursor:not-allowed;}"], _colors.snowWhiteAlpha, _colors.interactionPrimaryLightFg);
    }

    return (0, _styledComponents.css)(["&:disabled:disabled{background-color:", ";border-color:transparent;color:", ";cursor:not-allowed;}"], _colors.interactionSecondaryLight, _colors.interactionPrimaryLightFg);
  }

  if (variant === 'ghost') {
    return (0, _styledComponents.css)(["&:disabled:disabled{background-color:transparent;color:", ";cursor:not-allowed;}"], (0, _toColorString.default)(opacityColors.charcoal40));
  }

  return (0, _styledComponents.css)(["&:disabled:disabled{background-color:", ";border-color:transparent;color:", ";cursor:not-allowed;}"], (0, _toColorString.default)(opacityColors.charcoal15), (0, _toColorString.default)(opacityColors.charcoal40));
};

var StyledButton = (0, _styledComponents.default)(_BaseButton.default).withConfig({
  displayName: "StyledButton",
  componentId: "sc-1khcx6y-0"
})(["align-items:center;border-radius:", ";border:1px solid transparent;display:flex;font-weight:", ";justify-content:center;line-height:1;outline:none;text-transform:uppercase;white-space:nowrap;", ";", ";", ";", ";", ";", ";"], (0, _rem.default)(2), _designTokens.typography.weight.alias.default, color, _kind.default, _intent.default, buttonSizeModifier, (0, _dynamicModifiers.applyDynamicModifiers)('minWidth', 'min-width'), disabledStyles);
var _default = StyledButton;
exports.default = _default;